define('editor/edit/map/controls/textblock',['durandal/app', 'knockout', 'jquery', 'summernote', 'leaflet-text-block'], function (app, ko, $) {
  var control = function (options) {
    var self = this;

    self.options = options;
    self.layer = options.layer;

    if (!Object.keys(self.layer.state()).length) {
      self.layer.state({
        width: ko.observable(100),
        height: ko.observable(50),
        position: {
          x: ko.observable(0),
          y: ko.observable(0)
        },
        html: ko.observable('<h4>Text Block</h4><p>Description here...</p>')
      });
    }

    self.addToMap = function () {
      // use the our custom map pane as a container to attach the control to
      var controlContainer = self.options.mapControl._controlContainer;

      var opts = {
        container: controlContainer,
        viewport: {
          height: self.options.editorMap.height,
          width: self.options.editorMap.width
        }
      };

      $.extend(opts, ko.toJS(self.layer.state()));

      self.control = L.textBlock(opts);

      if (self.options.visible()) {
        self.show();
      }

      self.registerEventHandlers();
    };

    self.registerEventHandlers = function () {
      self.options.mapControl.on('textBlockMoved', self.handleTextBlockMoved);
      self.options.mapControl.on('textBlockResized', self.handleTextBlockResized);
    };

    self.deregisterEventHandlers = function () {
      self.options.mapControl.off('textBlockMoved', self.handleTextBlockMoved);
      self.options.mapControl.off('textBlockResized', self.handleTextBlockResized);
    };

    self.allowEdit = function () {
      if (self.layer.visible()) {
        self.control.enableEdit();
      }
    };

    self.preventEdit = function () {
      if (self.layer.visible()) {
        self.control.disableEdit();
      }
    };

    self.hide = function () {
      self.control.remove();
      self.deregisterEventHandlers();
    };

    self.show = function () {
      self.control.addTo(self.options.mapControl);
      self.control._container.style.zIndex = 1000 - self.layer.order();
    };

    self.remove = function () {
      self.hide();
      self.deregisterEventHandlers();
    };

    self.handleTextBlockMoved = function (e) {
      self.layer.state().position = {
        x: ko.observable(e.x),
        y: ko.observable(e.y)
      };
    };

    self.handleTextBlockResized = function (e) {
      self.layer.state().width(e.width);
      self.layer.state().height(e.height);
    };
  };

  return control;
});
